
import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from
'@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import { ServiceWalkInModel } from '../model/index';

@Injectable()
export class AdvanceReturnService {
    private headers = new Headers({
        'Content-Type':
        'application/x-www-form-urlencoded', 'Accept':
        'q=0.8;application/json;q=0.9'
    });
    private advanceReturnUrl = 'api/advanceReturn';
    
    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getAdvanceReturnList(query: any): Promise<ServiceWalkInModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.advanceReturnUrl}/getAdvanceReturnList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    addSerialno(pageData: any): Promise<any> {
        const url = `${this.advanceReturnUrl}/addSerialno`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }
    getAdvanceNo(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.advanceReturnUrl}/getAdvanceNo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    getModelname(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.advanceReturnUrl}/getModelname`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(err => [JSON.parse(err._body)]);
    }
    

    addSaveAdvanceReturn(pageData: any): Promise<any> {
        const url = `${this.advanceReturnUrl}/addSaveAdvanceReturn`;
        return this.http
            .post(url, $.param(pageData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);

    }
 
    getAdvanceReturnDetails(data: any): Promise<ServiceWalkInModel> {

        const url = `${this.advanceReturnUrl}/getAdvanceReturnDetails`;

        return this.http
            .post(url, $.param(data), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }

    deleteAdvanceReturn(walkInData: any): Promise<ServiceWalkInModel> {
        const url = `${this.advanceReturnUrl}/deleteAdvanceReturn`;
        return this.http
            .post(url, $.param(walkInData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as ServiceWalkInModel)
            .catch(this.handleError);
    }
 
    private handleError(error: any): Promise<ServiceWalkInModel> {
        //console.error('An error occurred', error); // for demo
        //purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/advanceReturn.service.ts